import { createElement, memo, useActionState, useEffect } from "react";
import { access, isString, logTimestamp, split, useProperty } from "../../support/general";
import { sendCommand } from "../../support/LocalCommand";
import { makeUniversalBlockKey, modelStore } from "../storage/model";
import $ from "jquery"
import { makeStore } from "../../support/pile";
import { blockDmlToDhtml, dmlToDhtml, ensureBlockDmlCache } from "../storage/dml";
import { makeAndExecuteBlockLevelUpdate, makeBlockTextUpdate, makeRange } from "../storage/changes";
import { doChange, makeChange, undoChange } from "../storage/changes_admin";
import { showMenu } from "../../support/popup";
import { getNodeIdParent } from "./EPagedSubscript";

export function doDefaultKeyHandling (event,scriptId,subscriptId){

    var handled = false;
    var key = event.key;
    var qualifiers = (event.altKey?"a":"-") + (event.ctrlKey?"c":"-") + (event.metaKey?"m":"-")  + (event.shiftKey?"s":"-");

    if (event.isComposing){
        handled = true;
    } else {
        if (
            (event.key.substring(0,5)=='Arrow') ||
            (event.key.substring(0,4)=='Page') ||
            (event.key=='Home') ||
            (event.key=='End')
        )    {
            handled = true;
        } else {

            var qualifiers = (event.altKey?"a":"-") + (event.ctrlKey?"c":"-") + (event.metaKey?"m":"-")  + (event.shiftKey?"s":"-");
            
            // ignore caps lock
            if (key.length==1){
                if (qualifiers.indexOf("s")==-1) {
                    key = key.toLowerCase();
                } if (qualifiers.indexOf("s")!=-1) {
                    key = key.toUpperCase();
                }
            }

            if ( key=='z' && qualifiers=='-c--') {
                undoChange(scriptId,subscriptId);
                handled = true;
            } else if (key.length==1 && ((qualifiers == "----") || (qualifiers == "---s")) ){ 
                // simple character to be inserted into the text
                if (qualifiers != "---s") {
                    key = key.toLowerCase();
                }
            }
        }
    }

    return {
        handled,
        key,
        qualifiers
    }
}

export function NoteTable({scriptId,subscriptId,blockId}){

    var blockUid = makeUniversalBlockKey(scriptId,blockId);

    var block = modelStore.useSelector(data=>{
        //logTimestamp("block selector")
        var r = "none_0_empty"
        var block = data.model.Block[blockUid];
        if (block){
            //ensureBlockDmlCache(block);
            var indent = block.meta.indent;
            indent = indent?indent:0;
            r = block.type+"_"+indent+"_"+block.text;
        }
        return block;//r
    },blockUid);

    var orderedIds = modelStore.useSelector(state=>{
        return access(state,["model","Script",scriptId,"subscripts",subscriptId,"orderedIds"]);
    },scriptId+"_"+subscriptId);

    var type = block?block.type:'none';
    //var text = block?blockDmlToDhtml(scriptId,block):"";
    var text = block?block.text:"";

    var rows = [];
    var tableWidth = 0;
    if (block && orderedIds){
        
        var cellBlocks = {};
        var headerIndex = orderedIds.indexOf(block.id);
        var Blocks = modelStore.state.model.Block;
        var blockIndex = headerIndex+1;
        while (true){
            if (blockIndex>=orderedIds.length){
                break;
            }
            var cellBlockId = orderedIds[blockIndex];
            var cellBlock = Blocks[makeUniversalBlockKey(scriptId,cellBlockId)];
            if (cellBlock.type!="table_cell"){
                break;
            }
            cellBlocks[cellBlock.meta.column+"_"+cellBlock.meta.row] = cellBlock;
        }
        
        var columns = block.meta.columns;
        var numberOfRows = block.meta.numberOfRows;
        for (var r = 0 ; r<numberOfRows ; r++){
            var cells = [];
            for (var c = 0;c<columns.length;c++){
                var width = columns[c];
                 var cellBlock = cellBlocks[c+"_"+r];
                 var cellBlockId = cellBlock?cellBlock.id:0;
                 cells.push( < TableCell style = {{width:width+"em"}} headerBlockId = {block.id} scriptId = {scriptId} blockId={cellBlockId} />)
            }
            rows.push(<tr >
                {cells}
            </tr>);   
        }
        $.each(columns,(c,width)=>{tableWidth+=width});
    }    

    

    function onKeyDown(event){
                
        const {
            handled,
            key,
            qualifiers
        } = doDefaultKeyHandling(event,scriptId,subscriptId);

        if ( handled ) {
            event.stopPropagation();
            return;
        }

        if ( key.length==1 && ( (qualifiers == "----") || (qualifiers == "---s") ) ){ 
            // simple character to be inserted into the text
            insertLetterIntoCell(scriptId,subscriptId,key);
        } else if (key=="Enter" ) {
            insertEnterIntoCell(scriptId,subscriptId);
        } else if (key=="Delete" ) {
            doDeletionInCell(scriptId,subscriptId);
        } else if (key=="Backspace") {
            doBackspaceInCell(scriptId,subscriptId);
        } else if (qualifiers == "--m-"){
            // do nothing but don't return
        } else {
            return // don't stop default behavior
        }

        event.stopPropagation();
        event.preventDefault();
    }
    
    return (<div
        id = {blockUid}
        className = {"block block_"+type}
        contentEditable = "false"
        suppressContentEditableWarning={true}
        style={{
            width : '100%',
        }}

        // onFocus = {onFocus}
        onDrop = {(e)=>{
            if(e.stopPropagation) e.stopPropagation();
            if(e.preventDefault) e.preventDefault();
            e.cancelBubble=true;
            e.returnValue=false;
            return false;
        }}
    >
        <table style={{
                borderTop : 'solid 1px grey',
                borderLeft : 'solid 1px grey',
                tableLayout : 'fixed',
                width : tableWidth+"em",
            }}
            onKeyDown = {onKeyDown}
            contentEditable = "true"
            suppressContentEditableWarning={true}
        >
            <tbody>
                {rows}
            </tbody>
        </table>
    </div>)

}


function insertEnterIntoCell(scriptId,blockId){

}
function doDeletionInCell(scriptId,blockId){

}
function doBackspaceInCell(scriptId,blockId){

}
function TableCell({scriptId,blockId,style,headerBlockId}){

function onContextMenu(e){
    // if (e.buttons==2){
        showMenu({at:{x:e.clientX,y:e.clientY},items:[
            {
                name : 'Delete Table',
                onClick : ()=>{}
            },{
                name : 'Insert Row Below',
                onClick : ()=>{}
            },{
                name : 'Insert Row Above',
                onClick : ()=>{}
            },{
                name : 'Delete Row',
                onClick : ()=>{}
            },{
                name : 'Insert Column Right',
                onClick : ()=>{}
            },{
                name : 'Insert Column Left',
                onClick : ()=>{}
            },{
                name : 'Delete Column',
                onClick : ()=>{}
            }
        ]})
        e.preventDefault();
        e.stopPropagation();                    
        return false;
    // }
    }

    var block = modelStore.useSelector(state=>{
        return state.access(["model","Block",makeUniversalBlockKey(scriptId,blockId)]);
    },blockId);
    var text = block?block.text:"x";
    style = $.extend({
        borderRight : 'solid 1px grey',
        borderBottom : 'solid 1px grey',
    },style);
    return (<td 
        style={style}
        onContextMenu = {onContextMenu}
    >
        {text}
    </td>);
}

export function insertTable(scriptId,subscriptId,inertAtPosition){

    makeAndExecuteInsertTableUpdate ( scriptId,subscriptId,inertAtPosition,4,5);

}

function makeAndExecuteInsertTableUpdate(scriptId,subscriptId,inertAtPosition,numberOfRows,numberOfColumns){

    var change = makeChange(scriptId,subscriptId,{

        executeDo : function(state,scriptId,subscriptId,dirty) {
                        
            var columns = [];
            for ( var c = 0 ; c < numberOfColumns ; c++ ) {
                columns.push(20);
            }

            var newBlock = {
                type : "noteTable",
                meta : {
                    columns ,
                    numberOfRows ,
                }
            };

            state.insertBlock( scriptId , subscriptId , inertAtPosition , newBlock , dirty );

            return {
                undo : {
                    targetAt : inertAtPosition,
                    numberToDelete : 1,
                    blocksToReinstate : [],
                },
            }

        }

    });

    doChange(change);
}



function getTableSelection() {

    const selection = window.getSelection();
    
    var fromNode = getNodeIdParent(selection.anchorNode);
    var focusNode = getNodeIdParent(selection.focusNode);
    if (fromNode !== focusNode){
        return null;
    }

    // if (fromNode && fromNode.id.substring(0,4)=="dml_"){
    //     return getDmlBlockSelection(selection);
    // } else {
    //     var fromBlock = nodeToBlock(selection.anchorNode);
    //     if (fromBlock){

    //         var fromOffset = selection.anchorOffset;
    //         var toBlock = nodeToBlock(selection.focusNode);
    //         var toOffset = selection.focusOffset;
    //         var scriptId = fromBlock.scriptId;
    //         var subscriptId = fromBlock.subscriptId;

    //         if (selection.type=='Range') {

    //             var fromPosition = modelStore.state.getBlockPosition(scriptId,subscriptId,fromBlock.id);
    //             var toPosition = toBlock?modelStore.state.getBlockPosition(scriptId,subscriptId,toBlock.id):fromPosition;
    //             if (fromPosition == toPosition){
    //                 if (toOffset<fromOffset){
    //                     var temp = fromOffset;
    //                     fromOffset = toOffset;
    //                     toOffset = temp;
    //                 }
    //                 return {
    //                     blocks :  [fromBlock],
    //                     fromOffset : fromOffset,
    //                     toOffset : toOffset,
    //                     isNotRange : toOffset==fromOffset,
    //                 }
    //             } else {
    //                 if (toPosition<fromPosition){
    //                     var temp = toBlock;toBlock=fromBlock;fromBlock = temp;
    //                     temp = toOffset;toOffset=fromOffset;fromOffset = temp;
    //                     temp = toPosition;toPosition=fromPosition;fromPosition = temp;
    //                 }
    //                 return {
    //                     blocks :  modelStore.state.getBlocksFromPosition(scriptId,subscriptId,fromPosition,(toPosition-fromPosition)+1),
    //                     fromOffset : fromOffset,
    //                     toOffset : toOffset,
    //                     isNotRange : false,
    //                     fromDmlOffset : [],
    //                     toDmlOffset : [],
    //                     isDml : false,

    //                 }
    //             }
    //         } else {
    //             return {
    //                 blocks : [fromBlock],
    //                 fromOffset : fromOffset,
    //                 toOffset : fromOffset,
    //                 isNotRange : true,
    //                 isDml : false,
    //                 fromDmlOffset : [],
    //                 toDmlOffset : [],
    //             }
    //         }
        
    //     } else {
    //         return {
    //             blocks : [],
    //             fromOffset : 0,
    //             toOffset : 0,
    //             isNotRange : true,
    //             fromDmlOffset : [],
    //             toDmlOffset : [],
    //             isDml : false,   
    //         }
    //     }
    
    // }

    return {
        // tableHeaderBlock,
        // tableHeaderBlockAt,
        // row,
        // column,
        // cellBlock,
        // cellBlockAt,
        // startOffset,
        // endOffset
    }
    
}

function insertLetterIntoCell(scriptId,subscriptId,key){

    var tableSelection = getTableSelection();
    if (tableSelection){

        var update = null;


        if (tableSelection.cellBlock){

            
            update = {

                 executeDo : function (state,scriptId,subscriptId,dirty){

                    state.insertBlock(scriptId , subscriptId , tableSelection.tableHeaderBlockAt+1 , [{
                        type : "tableCell",
                        text : key,
                        meta : {
                            tableRow : tableSelection.row,
                            tableColumn : tableSelection.column
                        }
                    }] , dirty);

                    return {
                        undo : {
                            targetAt : tableSelection.tableHeaderBlockAt+1,
                            numberToDelete : 1,
                            blocksToReinstate : [],
                        }
                    };

                }

            }


        } else {

            update = makeBlockTextUpdate({
                sizeOfDeletion : 0,
                targetAt : tableSelection.cellBlockAt,
                targetOffset : tableSelection.startOffset,
                deletionEndOffset : tableSelection.endOffset,

                leadInsertionText : "",
                insertionBlocks : [{type:'text',text:key}],
                trailingText : ""

            });


        }

        var rangeBefore = makeRange(scriptId,subscriptId,tableSelection);

        var change = makeChange(scriptId,subscriptId,update,rangeBefore);
        // doChange(change);
    } 
    // return access (modelStore.state,["model","Block",makeUniversalBlockKey(scriptId,baseBlock.id)]);

}

function deleteTable(scriptId,subscriptId,hederBlockId){

}

function insertRows(scriptId,subscriptId,hederBlockId){

}

function insertColumns(scriptId,subscriptId,hederBlockId){

}

function deleteRows(scriptId,subscriptId,hederBlockId){

}

function deleteColumns(scriptId,subscriptId,hederBlockId){

}

function moveRow(scriptId,subscriptId,hederBlockId){

}

function moveColumn(scriptId,subscriptId,hederBlockId){

}
